import request from './request'

export function getBanner(data) {
    return request({
        url: '/api/getBanner',
        method: 'get',
        params: data
    })
}
